import { Component } from '@angular/core';

@Component({
  selector: 'app-configuracao-whatsapp',
  standalone: false,
  templateUrl: './configuracao-whatsapp.component.html',
  styleUrl: './configuracao-whatsapp.component.css'
})
export class ConfiguracaoWhatsappComponent {

}
